export default function () {
    $('#passwordMatchFailMsg').hide();
    $('#passwordCriteriaFailMsg').hide();
    $('#passwordCurrentMatchMsg').hide();
    $('#verifyPassword').keyup(function () {
        verifyPassword();
    });
    $('#newPassword').keyup(function () {
        passwordCriteriaCheck();
    });
}

const verifyPassword = () => {
    let $verifyPassword = $('#verifyPassword'), 
      $password = $('#newPassword'), 
      $passwordMatchError = $('#passwordMatchFailMsg'), 
      $resetBtn = $('#submitPasswordResetBtn');

    if ($verifyPassword.val() !== $password.val()) {
        $passwordMatchError.show();
        $resetBtn.attr('disabled', true);
        return;
    }

    $passwordMatchError.hide();
    $resetBtn.attr('disabled', false);
};

const passwordCriteriaCheck = () => {
    let $password              = $('#newPassword'),
        $passwordCriteriaError = $('#passwordCriteriaFailMsg'),
        password               = $password.val(),
        uppercaseLetter        = new RegExp('[A-Z]').test(password),
        lowercaseLetter        = new RegExp('[a-z]').test(password),
        specialCharacters      = new RegExp('[!@#$%^&*(),.?":{}|<>]').test(password),
        numericCharacter       = new RegExp('[0-9]').test(password),
        passwordLength         = password.length,
        $resetBtn              = $('#submitPasswordResetBtn'),
        passCount              = 0;

    if (uppercaseLetter) passCount++;
    if (lowercaseLetter) passCount++;
    if (specialCharacters) passCount++;
    if (numericCharacter) passCount++;
    if (passwordLength < 8 || passwordLength > 64 || passCount < 3) {
        $passwordCriteriaError.show();
        $resetBtn.attr('disabled', true);
        return;
    }

    $passwordCriteriaError.hide();
    $resetBtn.attr('disabled', false);
};
